export default function (minute) {
    return minute * 60 * 1000;
}
